
import { Vue, Component, Prop } from "vue-property-decorator";
import InputFilter from "@/components/filters/InputFilter.vue";
import debounce from "lodash-es/debounce";
@Component({
  components: {
    InputFilter,
  },
})
export default class Search extends Vue {
  @Prop({ type: Number, default: undefined }) debounceTime!: number;
  @Prop({ type: String, default: undefined }) placeholderText: string;
  @Prop({ type: String, default: undefined }) readonly id?: string;
  @Prop({ type: [String, Number], default: undefined }) readonly value?:
    | string
    | number;
  @Prop({ type: String, default: undefined }) readonly name?: string;
  @Prop({ type: String, default: undefined }) readonly height?: string;
  @Prop({ type: String, default: undefined }) readonly placeholder?: string;
  @Prop({ type: String, default: "text" }) readonly type!: string;
  @Prop({ type: Boolean, default: false }) readonly invalid!: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: "bg-white" }) readonly inputClass!: string;
  @Prop({ type: String }) classes!: any;

  handleInput = debounce((event: Event): void => {
    const el = event.target as HTMLInputElement;
    const rawValue = el?.value;

    this.$emit("search", rawValue);
  }, this.debounceTime);
}
